import { PrintCodesSagaWatcher } from './PrintCodes/services/saga';
import { SearchCodesSagaWatcher } from './SearchCodes/services/saga';

export const operationsModuleSaga = [PrintCodesSagaWatcher, SearchCodesSagaWatcher];
